// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__wd_rW","midContainer":"footer_midContainer__FHJDO","bottomContainer":"footer_bottomContainer__b292b","FooterNote":"footer_FooterNote__iRd3t"};